export const COLLAPSED = "COLLAPSED";
export const IFRAME = "IFRAME";
export const IFRAME_LOADING = "IFRAME_LOADING";
